import { INITIAL_STATE, NEXT, PREV, FIRST, LAST } from './constants.js';

var getTotalPages = function getTotalPages(totalItems, pageSize) {
  return totalItems > pageSize ? Math.ceil(totalItems / pageSize) : 1;
};
var getValidCurrentPage = function getValidCurrentPage(currentPage, totalPages) {
  if (!currentPage || !totalPages) {
    return INITIAL_STATE.currentPage;
  }
  if (currentPage > totalPages) {
    // Go to the last available page
    return totalPages;
  }
  return currentPage;
};
var getItemRange = function getItemRange(_ref) {
  var page = _ref.page,
    pageSize = _ref.pageSize,
    totalItems = _ref.totalItems;
  var totalPages = getTotalPages(totalItems, pageSize);
  if (page > totalPages) {
    console.error("Hey Canvas User! The page number:".concat(page, " cannot exceed the number of total pages: ").concat(totalPages, "."));
    return;
  }
  if (page <= 0) {
    console.error("Hey Canvas User! The page number starting range is 1.");
    return;
  }
  var startItem = (page - 1) * pageSize + 1;
  var endItem = totalPages === page ? totalItems : startItem + pageSize - 1;
  return {
    end: endItem,
    start: startItem
  };
};

// When paging, get new range of items
var getPageWithRange = function getPageWithRange(_ref2, direction) {
  var currentPage = _ref2.currentPage,
    pageSize = _ref2.pageSize,
    totalPages = _ref2.totalPages,
    totalItems = _ref2.totalItems;
  var selectedPage;
  if (direction === NEXT) {
    selectedPage = currentPage <= totalPages ? currentPage + 1 : currentPage;
  }
  if (direction === PREV) {
    selectedPage = currentPage > 1 ? currentPage - 1 : currentPage;
  }
  if (direction === FIRST) {
    selectedPage = 1;
  }
  if (direction === LAST) {
    selectedPage = totalPages;
  }
  if (direction === undefined) {
    selectedPage = currentPage;
  }
  return {
    currentPage: selectedPage,
    itemRange: getItemRange({
      page: selectedPage,
      pageSize: pageSize,
      totalItems: totalItems
    }),
    pageSize: pageSize
  };
};
var getChangedPageSize = function getChangedPageSize(_ref3, newPageSize) {
  var currentPage = _ref3.currentPage,
    pageSize = _ref3.pageSize,
    totalItems = _ref3.totalItems;
  // When page size changes, try to keep the user in a familiar result set
  var projectedIndex = currentPage * pageSize;
  var currentIndex = projectedIndex > totalItems ? totalItems : projectedIndex;
  var newPage = Math.ceil(currentIndex / newPageSize) || 1;
  var totalPages = getTotalPages(totalItems, newPageSize);
  return {
    currentPage: newPage,
    itemRange: getItemRange({
      page: newPage,
      pageSize: newPageSize,
      totalItems: totalItems,
      totalPages: totalPages
    }),
    pageSize: newPageSize,
    totalPages: totalPages
  };
};

export { getChangedPageSize, getItemRange, getPageWithRange, getTotalPages, getValidCurrentPage };
